import React, { ChangeEventHandler, useEffect, useState } from 'react';
import userAvater from '../../../../../Assets/images/user-empty-avatar.png';
import { useNavigate } from 'react-router-dom';
interface ApplicationStage2Props {
  setValue(arg0: string, currentAGE: number): unknown;
  changeFormData: ChangeEventHandler<HTMLSelectElement> | undefined;
  states: any;
  formData: any;
  lgas: any;
  boxErrorMessage: string;
  ninValidated: boolean;
  displayForm: boolean;
  newPhotoInputRef?: React.RefObject<HTMLInputElement>;
  changeNewPhoto: (event: React.ChangeEvent<HTMLInputElement>) => void;
  nimcData: any;
  Base64AppendString: string;
  currentPage: number;
  register: any;
  errors: any;
  trigger: any;
  loadAssert: any;
  manifestInfo: any
  setCurrentPage: (page: number) => void;
  setCurrentDocument: (docType: string) => void;
}
export default function ApplicationStage2 (props: ApplicationStage2Props) {
  // const data = props.watch('surname');
  // const removeBackslash =
  // console.log('NIMC DATA IN STAGE 2:', props);
  const [currentAGE, setCurrentAGE] = useState(0);
  useEffect(() => {
    if (props?.nimcData?.dateOfBirth) {
      const date = new Date(props.nimcData.dateOfBirth);
      // const day = String(date.getDate()).padStart(2, '0');
      // const month = String(date.getMonth() + 1).padStart(2, '0');

      const year: number = date.getFullYear();
      // console.log('DOB YEAR:', `${day}/${month}/${year}`);
      calculateAge(year);
    }
  }, []);
  const formatDate = (dateString: string) => {
    if (!dateString) return '';

    const date = new Date(dateString);

    // padStart(2, '0') ensures "5" becomes "05"
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year: number = date.getFullYear();
    calculateAge(year);
    return `${day}/${month}/${year}`;
  };
  // console.log('form nimc', props.nimcData);
  // const firstname = props.nimcData.photo
  // const [triggerState, setTriggerState] = React.useState(false);
  const calculateAge = (birthYear: number) => {
    const currentYear = new Date().getFullYear();

    // Correct logic: Current Year - Birth Year
    const currentAge = currentYear - birthYear;

    console.log(currentAge);
    setCurrentAGE(currentAge);
    props.setValue('age', currentAge);
    return currentAge; // Ideally return the value to use it elsewhere
  };
  const validateForm = async () => {
    const result = await props.trigger();
    // console.log(result);
    if (result) {
      props.setCurrentPage(props.currentPage + 1);
    }
  };
  const navigate = useNavigate();
  // console.log('HTTP', props.nimcData.photo);
  return (
    <div className='pb-1'>
      {!props.boxErrorMessage && (
        <>
          <div className='pt-2 '></div>
          <section
            className={`card border-0 rounded-3 w-100 my-5 rounded ${
              props.boxErrorMessage ? ' d-none' : ''
            } ${!props.ninValidated ? ' d-none' : ''} ${
              !props.displayForm ? ' d-none' : 'd-block'
            }`}
            id='personal'
          >
            <div className='bg-white my-2'>
              <div className='section-item-container p-1'>
                <h3 className='sub-heading__pinfo'>Personal Information</h3>
              </div>
              <div className='row row-cols-lg-2 row-cols-md-1 row-cols-sm-1 row-cols-1 p-3'>
                <div>
                  <input
                    ref={props.newPhotoInputRef}
                    type='file'
                    onChange={props.changeNewPhoto}
                    style={{ display: 'none' }}
                    name='new-photo'
                    id='new-photo'
                    disabled={props.manifestInfo?.passport?.upload}
                    accept=".jpg, .jpeg, image/jpeg"
                  />
                  <div
                    className={`w-0 section-persional-container-pro p-2${
                      !props.ninValidated ? ' d-none' : ''
                    }`}
                  >
                    <div
                      className='section-persional-pro shadow nimc-photo text-center'
                      onClick={() => {
                        props.newPhotoInputRef!.current!.click();
                        props.setCurrentDocument('passport');
                      }}
                    >
                      <img
                        src={
                          props?.nimcData?.photo
                            ? `${props.nimcData.photo}`
                            : userAvater
                        }
                        className='section-persional-pro'
                        // width={100 }
                        // height={100}
                      />
                    </div>
                  </div>
                  <p className='text-danger text-center'>
                    max passport size 200kb
                  </p>
                </div>
                <div className='row row-cols-md-2 row-cols-lg-1 row-cols-1 p-0 m-0 pt-md-3 pt-0'>
                  <div
                    className={`col-md-6${
                      !props.ninValidated ? ' d-none' : ''
                    }`}
                  >
                    <div className='form-group padright'>
                      <label className='control-label' htmlFor='surname'>
                        Surname<span id='compulsory'>*</span>
                      </label>
                      <div className='input-group'>
                        <div className='input-group-prepend'>
                          <div className='input-group-text'>
                            <i className='fa fa-user text-default'></i>
                          </div>
                        </div>
                        <input
                          type='text'
                          className='custom-form-control form-control'
                          id='surame'
                          // disabled={props?.nimcData?.lastName !== '' && props.formData?.lastName !== ''}
                          defaultValue={props.formData?.lastName || ""}
                          placeholder='Surname'
                          {...props.register('surName', {
                            required: 'surname field is required',
                          })}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-md-6${
                      !props.ninValidated ? ' d-none' : ''
                    }`}
                  >
                    <div className='form-group padleft'>
                      <label className='control-label' htmlFor='firstname'>
                        First Name<span id='compulsory'>*</span>
                      </label>
                      <div className='input-group'>
                        <div className='input-group-prepend'>
                          <div className='input-group-text'>
                            <i className='fa fa-user text-default'></i>
                          </div>
                        </div>
                        <input
                          type='text'
                          className='custom-form-control form-control'
                          id='firstname'
                          // eslint-disable-next-line no-unneeded-ternary
                          disabled={props?.nimcData?.firstName !== '' || props.formData?.firstname !== ''}
                           defaultValue={props.formData?.firstname || ""}
                          placeholder='Firstname'
                          {...props.register('firstname', {
                            required: 'firstname field is required',
                          })}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-md-6${
                      !props.ninValidated ? ' d-none' : ''
                    }`}
                  >
                    <div className='form-group padright'>
                      <label className='control-label' htmlFor='middlename'>
                        Other Names
                      </label>
                      <div className='input-group'>
                        <div className='input-group-prepend'>
                          <div className='input-group-text'>
                            <i className='fa fa-user text-default'></i>
                          </div>
                        </div>
                        <input
                          type='text'
                          className='custom-form-control form-control'
                          id='middlename'
                          placeholder='Middle Name'
                          {...props.register('middlename')}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row pb-3 px-3'>
                <div
                  className={`form-group col-md-6 padleft${
                    !props.ninValidated ? ' d-none' : ''
                  }`}
                >
                  <label className='control-label' htmlFor='gender'>
                    Gender<span id='compulsory'>*</span>
                  </label>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <div className='input-group-text'>
                        <i className='fa fa-transgender text-default'></i>
                      </div>
                    </div>
                    <select
                      className='form-control custom-form-control'
                      id='gender'
                      defaultValue={props.formData?.gender || ""}
                      disabled={props?.nimcData?.gender !== ''}
                      {...props.register('gender', {
                        required: 'gender field is required',
                      })}
                    >
                      <option value=''>---select gender---</option>
                      <option value='m'>Male</option>
                      <option value='f'>Female</option>
                    </select>
                  </div>
                </div>

                <div className='form-group col-md-6 padleft'>
                  <label className='control-label' htmlFor='phone'>
                    Phone number<span id='compulsory'>*</span>
                  </label>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <div className='input-group-text'>
                        <i className='fa fa-phone text-default'></i>
                      </div>
                    </div>
                    <input
                      type='number'
                      className='custom-form-control form-control'
                      id='phone'
                       defaultValue={props.formData?.phoneno || props.nimcData?.phone || ""}
                      placeholder='Phone number'
                      {...props.register('phoneno', {
                        required: 'phone field is required',
                      })}
                    />
                  </div>
                </div>

                <div className='form-group col-md-6 padleft'>
                  <label className='control-label' htmlFor='phone'>
                    Phone number<span id='compulsory'>*</span>
                  </label>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <div className='input-group-text'>
                        <i className='fa fa-phone text-default'></i>
                      </div>
                    </div>
                    <input
                      type='number'
                      className='custom-form-control form-control'
                      id='phone2'
                       defaultValue={props.formData?.phone2 || ""}
                      placeholder='Phone number 2'
                      min='0'
                      {...props.register('phone2')}
                    />

                    {props.errors.phone2 && (
                      <small className='error-value'>
                        Please, provide an optional phone number
                      </small>
                    )}
                  </div>
                </div>

                <div className='form-group col-md-6 padleft'>
                  <label className='control-label' htmlFor='email'>
                    Email<span id='compulsory'>*</span>
                  </label>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <div className='input-group-text'>
                        <i className='fa fa-envelope text-default'></i>
                      </div>
                    </div>
                    <input
                      className='custom-form-control form-control'
                      id='email'
                      placeholder='Email'
                      disabled={false}
                       defaultValue={props.formData?.email || ""}
                      {...props.register('email', {
                        required: true,
                        pattern:
                          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
                      })}
                    />
                  </div>
                  {props.errors.email && (
                    <small className='error-value'>
                      Please, provide a valid email
                    </small>
                  )}
                </div>

                <div
                  className={`form-group col-md-6 padright${
                    !props.ninValidated ? ' d-none' : ''
                  }`}
                >
                  <label className='control-label' htmlFor='marital_status'>
                    Marital Status
                  </label>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <div className='input-group-text'>
                        <i className='fa fa-heart text-default'></i>
                      </div>
                    </div>
                    <select
                      className='form-control custom-form-control'
                      id='maritalStatus'
                       defaultValue={props.formData?.maritalStatus || ""}
                      {...props.register('maritalStatus', {
                        required: 'maritalStatus field is required',
                      })}
                    >
                      <option value=''>Select Marital Status</option>
                      <option value='single'>Single</option>
                      <option value='married'>Married</option>
                    </select>
                  </div>
                  {props.errors.maritalStatus && (
                    <small className='error-value'>
                      This field is required
                    </small>
                  )}
                </div>

                <div
                  className={`form-group col-md-6 padleft${
                    !props.ninValidated ? ' d-none' : ''
                  }`}
                >
                  <label className='control-label' htmlFor='dob'>
                    Date of Birth<span id='compulsory'>*</span>
                  </label>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <div className='input-group-text'>
                        <i className='fa fa-clock text-default'></i>
                      </div>
                    </div>
                    <input
                      className='custom-form-control form-control'
                      id='dob'
                      placeholder='dob'
                         defaultValue={props.formData?.dateOfBirth || ""}
                      type='date'
                      min='1997-01-01'
                      disabled={props.nimcData.dateOfBirth !== ''}
                      {...props.register('dob', {

                        required: 'Date of Birth field is required',
                        onChange: (e: any) => {
                          calculateAge(e);
                          formatDate(e.target.value);
                        },
                      })}
                    />
                  </div>
                </div>
                <div
                  className={`form-group col-md-6 padleft${
                    !props.ninValidated ? ' d-none' : ''
                  }`}
                >
                  <label className='control-label' htmlFor='dob'>
                    Height (meters)<span id='compulsory'>*</span>
                  </label>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <div className='input-group-text'>
                        <i className='fa fa-user text-default'></i>
                      </div>
                    </div>
                    <input
                      className='custom-form-control form-control'
                      id='height'
                      placeholder='Height (max 2.50 meter)'
                         defaultValue={props.formData?.height || ""}
                      // disabled
                      {...props.register('height', {
                        required: 'Height field is required',
                        max: {
                          value: 2.5,
                          message: 'Height cannot be more than 2.50',
                        },
                        min: {
                          value: 0,
                          message: 'Height cannot be negative',
                        },
                      })}
                    />
                  </div>
                </div>

                <div
                  className={`form-group col-md-6 padleft${
                    !props.ninValidated ? ' d-none' : ''
                  }`}
                >
                  <label className='control-label' htmlFor='dob'>
                    Age<span id='compulsory'>*</span>
                  </label>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <div className='input-group-text'>
                        <i className='fa fa-clock text-default'></i>
                      </div>
                    </div>
                    <input
                      className='custom-form-control form-control'
                      id='age'
                      placeholder='age'
                      // type='date'
                      // dis
                      defaultValue={currentAGE}
                      disabled
                      {...props.register('age', {
                        require: "input can't be empty",
                        value: currentAGE,
                      })}
                    />
                  </div>
                </div>
              </div>
              {/* <hr/> */}
              <section
                className={`card border-0 px-2 rounded${
                  !props.ninValidated || props.boxErrorMessage ? ' d-none' : ''
                } ${!props.displayForm ? ' d-none' : 'd-block'}`}
                id='nxtkin'
              >
                {props.ninValidated && !props.boxErrorMessage && (
                  <section
                    className={` border-0  rounded ${
                      !props.displayForm ? ' d-none' : 'd-block'
                    }`}
                    id='pers'
                  >
                    <div className='bg-white'>
                      <div className='section-container'>
                        <div className='section-item-container'></div>
                        <div>
                          <h3 className='sub-heading__pinfo '>
                            State of Origin / Permanent Home Addres
                          </h3>
                        </div>
                        {/* <div className="col-md-12 subheading text-white text-center card-header section-header-bg w-100 p-3 m-0">
                          <h1>s</h1>
                        </div> */}
                        <div className='section-item-container'></div>
                      </div>
                      <div className='row p-3'>
                        <div className='form-group col-md-6 padright'>
                          <label className='control-label' htmlFor='country'>
                            Nationality<span id='compulsory'>*</span>
                          </label>
                          <div className='input-group'>
                            <div className='input-group-prepend'>
                              <div className='input-group-text'>
                                <i className='fa  fa-flag text-default'></i>
                              </div>
                            </div>
                            <select
                              className='form-control custom-form-control'
                              disabled
                              id='country'
                              // {...register('country', { required: true })}
                              value='410'
                            >
                              <option value=''>Select Country</option>
                              <option value='410'>Nigeria</option>
                            </select>
                          </div>
                          {props.errors.country && (
                            <small className='error-value'>
                              This field is required
                            </small>
                          )}
                        </div>

                        <div className='form-group col-md-6 padleft'>
                          <label className='control-label' htmlFor='state'>
                            State<span id='compulsory'>*</span>
                          </label>
                          <div className='input-group'>
                            <div className='input-group-prepend'>
                              <div className='input-group-text'>
                                <i className='fa fa-map-marker text-default'></i>
                              </div>
                            </div>
                            <select
                              className='form-control custom-form-control'
                              id='stateOfPermanent'
                                 defaultValue={props.formData?.stateOfPermanent || ""}
                              {...props.register('stateOfPermanent', {
                                required: true,
                              })}
                              onChange={props.changeFormData}
                            >
                              <option value=''>Select state</option>
                              {props.loadAssert.states &&
                                props.loadAssert?.states.map(
                                  (state: any, index: number) => (
                                    <option key={index} value={state.name}>
                                      {state.name}
                                    </option>
                                  )
                                )}
                            </select>
                          </div>
                          {props.errors.stateOfPermanent && (
                            <small className='error-value'>
                              This field is required
                            </small>
                          )}
                        </div>
                        <div className='for-group col-md-6 padright'>
                          <label className='control-label' htmlFor='lga'>
                            LGA<span id='compulsory'>*</span>
                          </label>
                          <div className='input-group'>
                            <div className='input-group-prepend'>
                              <div className='input-group-text'>
                                <i className='fa fa-map-marker text-default'></i>
                              </div>
                            </div>
                            <select
                              className='form-control custom-form-control'
                              // disabled
                              id='lgaOfPermanent'
                              defaultValue={props.formData?.lgaOfPermanent || ""}
                              {...props.register('lgaOfPermanent', {
                                required: true,
                              })}
                            >
                              <option value=''>Select LGA</option>
                              {props.formData.stateOfPermanent &&
                                props.loadAssert.lgas[2]?.data
                                  ?.filter(
                                    (y: { state_id: any }) =>
                                      String(y.state_id) ===
                                      String(props.loadAssert.states.find(
                                        (x: any) =>
                                          x?.name ===
                                          props.formData.stateOfPermanent
                                      )?.id)
                                  )
                                  .map((lga: any, index: number) => (
                                    <option key={index} value={lga.name}>
                                      {lga.name}
                                    </option>
                                  ))}
                            </select>
                          </div>
                          {props.errors.lgaOfPermanent && (
                            <small className='error-value'>
                              This field is required
                            </small>
                          )}
                        </div>
                        <div className='form-group col-md-6 padleft'>
                          <label
                            className='control-label'
                            htmlFor='streetAddressOfPermanent'
                          >
                            Street<span id='compulsory'>*</span>
                          </label>
                          <div className='input-group'>
                            <div className='input-group-prepend'>
                              <div className='input-group-text'>
                                <i className='fa fa-map-marker text-default'></i>
                              </div>
                            </div>
                            <input
                              type='text'
                              className='custom-form-control form-control'
                              defaultValue={props.formData?.streetAddressOfPermanent || ""}
                              id='streetAddressOfPermanent'
                              {...props.register('streetAddressOfPermanent', {
                                required: true,
                              })}
                            />
                          </div>
                          {props.errors.streetAddressOfPermanent && (
                            <small className='error-value'>
                              This field is required
                            </small>
                          )}
                        </div>
                        <div className='col-md-6 padright'>
                          <label
                            className='control-label'
                            htmlFor='mobile1_code'
                          >
                            Contact Phone <span id='compulsory'>*</span>
                          </label>
                          <div className='col-xs-12'>
                            <div className='form-group col-xs-4'>
                              <div className='input-group'>
                                <div className='input-group-prepend'>
                                  <div className='input-group-text'>
                                    <i className='fa fa-phone text-default'></i>
                                  </div>
                                </div>
                                <input
                                  type='number'
                                  className='custom-form-control form-control'
                                  defaultValue={props.formData?.contactPhone || ""}
                                  id='contactPhone'
                                  {...props.register('contactPhone', {
                                    minLength: 11,
                                    maxLength: 11,
                                  })}
                                  min='0'
                                />
                              </div>
                              {props.errors.contactPhone && (
                                <small className='error-value'>
                                  Please, provide a valid phone number
                                </small>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className='form-group col-md-6 padleft'>
                          <label
                            className='control-label'
                            htmlFor='postal_address'
                          >
                            Postal Address
                          </label>
                          <div className='input-group'>
                            <div className='input-group-prepend'>
                              <div className='input-group-text'>
                                <i className='fa fa-address-book text-default'></i>
                              </div>
                            </div>
                            <input
                              type='text'
                              id='postalAddress'
                              defaultValue={props.formData?.postalAddress || ""}
                              className='custom-form-control form-control'
                              placeholder='Postal Address'
                              {...props.register('postalAddress')}
                            />
                          </div>
                          {props.errors.postalAddress && (
                            <small className='error-value'>
                              This field is required
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  </section>
                )}
                {props.ninValidated && !props.boxErrorMessage && (
                  <section
                    className={` border-0  rounded ${
                      !props.displayForm ? ' d-none' : 'd-block'
                    }`}
                    id='resident'
                  >
                    <div className='bg-white'>
                      <div className='section-container'>
                        <div className='section-item-container'></div>
                        <div>
                          <h3 className='sub-heading__pinfo '>
                            Current Residential Address
                          </h3>
                        </div>
                        <div className='section-item-container'></div>
                      </div>
                      <div className='row p-3'>
                        <div className='form-group col-md-6 padright'>
                          <label
                            className='control-label'
                            htmlFor='state_of_residence'
                          >
                            State of Residence<span id='compulsory'>*</span>
                          </label>
                          <div className='input-group'>
                            <div className='input-group-prepend'>
                              <div className='input-group-text'>
                                <i className='fa fa-flag text-default'></i>
                              </div>
                            </div>
                            <select
                              className='form-control custom-form-control'
                              id='stateOfResidence'
                              defaultValue={props.formData?.stateOfResidence || ""}
                              {...props.register('stateOfResidence', {
                                required: true,
                              })}
                              onChange={props.changeFormData}
                            >
                              <option value=''>Select state</option>
                              {props.loadAssert.states.map(
                                (state: any, index: number) => (
                                  <option key={index} value={state.name}>
                                    {state.name}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                          {props.errors.stateOfResidence && (
                            <small className='error-value'>
                              This field is required
                            </small>
                          )}
                        </div>

                        <div className='form-group col-md-6 padleft'>
                          <label
                            className='control-label'
                            htmlFor='lga_of_residence'
                          >
                            LGA of Residence<span id='compulsory'>*</span>
                          </label>
                          <div className='input-group'>
                            <div className='input-group-prepend'>
                              <div className='input-group-text'>
                                <i className='fa fa-map-marker'></i>
                              </div>
                            </div>
                            <select
                              className='form-control custom-form-control'
                              id='lgaOfResidence'
                              defaultValue={props.formData?.lgaOfResidence || ""}
                              {...props.register('lgaOfResidence', {
                                required: true,
                              })}
                            >
                              <option value=''>Select LGA</option>
                              {props.formData.stateOfResidence &&
                                props.loadAssert.lgas[2]?.data
                                  ?.filter(
                                    (y: any) =>
                                      Number(y.state_id) ===
                                      Number(props.loadAssert.states.find(
                                        (x: any) =>
                                          x.name ===
                                          props.formData?.stateOfResidence
                                      )?.id)
                                  )
                                  .map((lga: any, index: number) => (
                                    <option key={index} value={lga.name}>
                                      {lga.name}
                                    </option>
                                  ))}
                            </select>
                          </div>
                          {props.errors.lgaOfResidence && (
                            <small className='error-value'>
                              This field is required
                            </small>
                          )}
                        </div>

                        <div className='col-md-12'>
                          <div className='form-group'>
                            <label
                              className='control-label'
                              htmlFor='street_address'
                            >
                              Street Address<span id='compulsory'>*</span>
                            </label>
                            <div className='input-group'>
                              <textarea
                                cols={30}
                                rows={4}
                                id='streetAddressOfResidence'
                                defaultValue={props.formData?.streetAddressOfResidence || ""}
                                className='custom-form-control form-control'
                                {...props.register('streetAddressOfResidence', {
                                  required: true,
                                })}
                              ></textarea>
                            </div>
                            {props.errors.streetAddressOfResidence && (
                              <small className='error-value'>
                                This field is required
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}
                <div className='bg-white px-2'>
                  {/* <div className='section-container'>
                <div className='section-item-container'></div>
                <div className='col-md-12 subheading text-white text-center card-header section-header-bg'>
                  <h1>Next of kin</h1>
                </div>
                <div className='section-item-container'></div>
              </div> */}
                  <div>
                    <h3 className='sub-heading__pinfo '>Next of kin</h3>
                  </div>

                  <div className='row p-2'>
                    <div className='col-md-6'>
                      <div className='form-group padright'>
                        <label className='control-label' htmlFor='kin_name'>
                          Name<span id='compulsory'>*</span>
                        </label>
                        <div className='input-group'>
                          <div className='input-group-prepend'>
                            <div className='input-group-text'>
                              <i className='fa fa-user text-default'></i>
                            </div>
                          </div>
                          <input
                            type='text'
                            className='custom-form-control form-control'
                            id='nextOfKinName'
                            defaultValue={props.formData?.nextOfKinName || ""}
                            {...props.register('nextOfKinName', {
                              required: 'Next Of Kin Name field is required',
                            })}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='form-group padleft'>
                        <label className='control-label' htmlFor='kin_phone'>
                          Phone<span id='compulsory'>*</span>
                        </label>
                        <div className='input-group'>
                          <div className='input-group-prepend'>
                            <div className='input-group-text'>
                              <i className='fa fa-phone text-default'></i>
                            </div>
                          </div>
                          <input
                            type='number'
                            className='custom-form-control form-control'
                            id='nextOfKinPhone'
                            defaultValue={props.formData?.nextOfKinPhone || ""}
                            {...props.register('nextOfKinPhone', {
                              required: true,
                              minLength: 11,
                              maxLength: 11,
                            })}
                          />
                        </div>
                        {props.errors.nextOfKinPhone && (
                          <small className='error-value'>
                            Please, provide a valid phone number
                          </small>
                        )}
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='form-group padright'>
                        <label className='control-label' htmlFor='kin_email'>
                          Email{' '}
                        </label>
                        <div className='input-group'>
                          <div className='input-group-prepend'>
                            <div className='input-group-text'>
                              <i className='fa fa-envelope text-default'></i>
                            </div>
                          </div>
                          <input
                            type='email'
                            className='custom-form-control form-control'
                            id='nextOfKinEmail'
                            defaultValue={props.formData?.nextOfKinEmail || ""}
                            {...props.register('nextOfKinEmail', {
                              pattern:
                                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
                            })}
                          />
                        </div>
                        {props.errors.nextOfKinEmail && (
                          <small className='error-value'>
                            Please, provide a valid email
                          </small>
                        )}
                      </div>
                    </div>

                    <div className='form-group col-md-4 padleft'>
                      <label className='control-label' htmlFor='gender'>
                        Gender<span id='compulsory'>*</span>
                      </label>
                      <div className='input-group'>
                        <div className='input-group-prepend'>
                          <div className='input-group-text'>
                            <i className='fa fa-user text-default'></i>
                          </div>
                        </div>
                        <select
                          className='form-control custom-form-control'
                          id='nextOfKinGender'
                          defaultValue={props.formData?.nextOfKinGender || ""}
                          {...props.register('nextOfKinGender', {
                            required: true,
                          })}
                        >
                          <option value=''>Select gender</option>
                          <option value='male'>Male</option>
                          <option value='female'>Female</option>
                        </select>
                      </div>
                      {props.errors.nextOfKinGender && (
                        <small className='error-value'>
                          This field is required
                        </small>
                      )}
                    </div>

                    <div className='col-md-4'>
                      <div className='form-group padright'>
                        <label
                          className='control-label'
                          htmlFor='kin_relationship'
                        >
                          Relationship*{' '}
                        </label>
                        <div className='input-group'>
                          <div className='input-group-prepend'>
                            <div className='input-group-text'>
                              <i className='fa fa-link text-default'></i>
                            </div>
                          </div>
                          <input
                            type='text'
                            className='custom-form-control form-control'
                            defaultValue={props.formData?.nextOfKinRelationship || ""}
                            id='nextOfKinRelationship'
                            {...props.register('nextOfKinRelationship', {
                              required: true,
                            })}
                          />
                        </div>
                        {props.errors.nextOfKinRelationship && (
                          <small className='error-value'>
                            This field is required
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div className=' d-flex justify-content-between py-5 px-3'>
              <button
                className='btn btn-outline-secondary w-25 fw-bolder'
                onClick={() => navigate('/')}
              >
                Previous
              </button>
              <button
                className='btn btn-success w-25 fw-bolder'
                onClick={() => validateForm()}
              >
                Next
              </button>
            </div>
          </section>
        </>
      )}
    </div>
  );
}
